var _linearGradient, _linearGradient2, _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    size: 38,
    stroke: "primary.c50",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "sc-XxNYO cfhpbM",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-start",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-end",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "gradient-mask",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -4,
    width: 44,
    height: 22,
    strokeWidth: 0,
    fill: "url(#gradient-start)",
    transform: "rotate(10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18,
    width: 44,
    height: 21,
    strokeWidth: 0,
    fill: "url(#gradient-end)",
    transform: "rotate(10)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8807 20.9499C35.3608 17.0398 34.3815 13.09 32.1304 9.85712C29.8793 6.6242 26.5146 4.33541 22.6808 3.42914C18.847 2.52287 14.8136 3.06283 11.3532 4.94559C7.89277 6.82836 5.24858 9.92158 3.92708 13.6328C2.60558 17.344 2.69968 21.4123 4.19135 25.0584C5.68302 28.7045 8.4674 31.6722 12.0112 33.3929C15.5549 35.1137 19.609 35.4666 23.3968 34.384C27.1846 33.3015 30.4398 30.8596 32.5391 27.526",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#gradient-mask)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderIcon);
export default __webpack_public_path__ + "static/media/loader-icon.1b5d151d149cb7c5bce597aafdbaadee.svg";
export { ForwardRef as ReactComponent };